import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, unref as _unref, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/LOGO-Liberta-Financiamentos.svg'


const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "d-flex flex-column text-right" }
const _hoisted_4 = { class: "user-name" }

import { ref, computed } from "vue";
import { useLoginStore } from "@/modules/login/store/login_store";
import { loginService } from "@/shared/services/login_service";
import { useRoute, useRouter } from "vue-router";
import { useDetalhesProposta } from "@/modules/detalhes_proposta/store/detalhes_proposta_store";


export default /*@__PURE__*/_defineComponent({
  __name: 'NavbarComponent',
  setup(__props) {

const menu = ref(false);
const loginStore = useLoginStore();
const detalhesPropostaStore = useDetalhesProposta();
const route = useRoute();
const router = useRouter();

function logout() {
  loginService.logout();
}

const pageTitle = computed(() => {
  if (route.name === "DetalhesProposta") {
    return detalhesPropostaStore.currentStepName;
  }

  if (route.name === "Financiamentos") {
    return "Portal do Integrador";
  }

  return (route.meta?.title as string) ?? "";
});

const isActiveRoute = (routeName: string) => {
  return route.name === routeName;
};

const navigateTo = (routeName: string) => {
  router.push({ name: routeName });
};

// Menus baseados no perfil
const menuItems = computed(() => {
  const profileSlug = loginStore.authUser?.data?.profileSlug ?? "";

  switch (profileSlug) {
    case "Integrador":
    case "Adm-Integrador":
      return [
        { label: "Financiamentos", routeName: "Financiamentos" },
        { label: "Meus Dados", routeName: "MeusDados" },
      ];

    case "BackOffice-Engenharia":
      return [{ label: "Análises", routeName: "BackofficeEngenharia" }];

    case "BackOffice-Comercial":
      return [
        { label: "Integradores", routeName: "BackofficeComercial" },
        {
          label: "Financiamentos Reprovados",
          routeName: "FinanciamentosReprovados",
        },
      ];

    case "BackOffice-Financeiro":
      return [{ label: "Notas Fiscais", routeName: "BackofficeFinanceiro" }];

    case "Administrador":
      // Admin tem acesso a todos os menus
      return [
        { label: "Financiamentos", routeName: "Financiamentos" },
        { label: "Meus Dados", routeName: "MeusDados" },
        // { label: "Backoffice Engenharia", routeName: "BackofficeEngenharia" },
        // { label: "Backoffice Comercial", routeName: "BackofficeComercial" },
        // { label: "Backoffice Financeiro", routeName: "BackofficeFinanceiro" },
      ];

    default:
      return [];
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, {
    flat: "",
    height: "72",
    color: "white",
    class: "px-6 navbar"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        align: "center",
        class: "w-100"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "auto",
            class: "d-flex align-center"
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "Liberta Financiamentos",
                class: "logo"
              }, null, -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "auto",
            class: "d-flex align-center ga-6 menu-links"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItems.value, (item) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: item.routeName,
                  class: _normalizeClass(["menu-item", { active: isActiveRoute(item.routeName) }]),
                  onClick: ($event: any) => (navigateTo(item.routeName))
                }, _toDisplayString(item.label), 11, _hoisted_1))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            class: "d-flex justify-center",
            cols: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_2, _toDisplayString(pageTitle.value), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "auto",
            class: "d-flex justify-end"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_menu, {
                modelValue: menu.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((menu).value = $event)),
                transition: "fade-transition",
                location: "bottom end",
                "close-on-content-click": true
              }, {
                activator: _withCtx(({ props }) => [
                  _createElementVNode("div", _mergeProps({ class: "d-flex align-center ga-3 user-activator" }, props), [
                    _createVNode(_component_v_icon, {
                      size: "28",
                      color: "orange-darken-3"
                    }, {
                      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                        _createTextVNode(" mdi-account-circle-outline ", -1)
                      ]))]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_3, [
                      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "welcome" }, "Boas-vindas", -1)),
                      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(loginStore).usuarioLogado?.nome ?? ""), 1)
                    ]),
                    _createVNode(_component_v_icon, { size: "18" }, {
                      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                        _createTextVNode("mdi-chevron-down", -1)
                      ]))]),
                      _: 1
                    })
                  ], 16)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_sheet, {
                    elevation: "6",
                    class: "menu-sheet"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, { density: "compact" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                  _createTextVNode("Usuários", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_divider),
                          _createVNode(_component_v_list_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                  _createTextVNode("Perfis", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_divider),
                          _createVNode(_component_v_list_item, {
                            onClick: logout,
                            class: "sair-item"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                  _createTextVNode("Sair", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})